import { startStimulusApp } from '@symfony/stimulus-bridge'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
export const app = startStimulusApp(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers',
  true,
  /\.[jt]sx?$/
))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/records',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/add-users',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/fixtures',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/threat-categories',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/account-linking',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/system-reports',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/logs',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/reports',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/contacts',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/documents',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/meetings',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/api-keys',
  true,
  /\.[jt]sx?$/
)))

app.load(definitionsFromContext(require.context(
  '@symfony/stimulus-bridge/lazy-controller-loader!./js/controllers/sms-routes',
  true,
  /\.[jt]sx?$/
)))

// register any custom, 3rd party controllers here
// app.register('some_controller_name', SomeImportedController);
